import type { RootState } from "single-spa/store/types";

/**
 * @param stateSliceSelector - function that should return desired state slice
 * @returns - helper typed selector builder function for top level state properties
 */
export const createStatePropertySelector =
    <SLICE extends {}>(stateSliceSelector: (state: RootState) => SLICE) =>
    <PROPERTY extends keyof SLICE>(p: PROPERTY) =>
    (state: RootState) =>
        stateSliceSelector(state)[p];

/**
 * @param previous
 * @param current
 * @param shouldBe
 */
export const flagHasChanged = (previous: boolean | undefined, current: boolean, shouldBe = false) => {
    return typeof previous !== "undefined" && previous !== current && current === shouldBe;
};

/**
 * TODO: Can be moved somewhere to project commons
 * @param given
 */
export function createCancelable<ARGS extends unknown[], R extends Promise<unknown>>(
    given: (signal: AbortSignal, ...args: ARGS) => R,
) {
    let abortController = new AbortController();

    return function cancelableWrapper(...args: ARGS): R {
        abortController.abort();
        abortController = new AbortController();

        return given.apply(null, [abortController.signal, ...args]);
    };
}
